import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const Befriend = ({
  addFollowingFriend,
  setShowBefriend,
  befriendedUser: {
    channelid,
    role,
    avatar,
    firstname,
    lastname,
    jobtitle,
    location,
  },
}) => {
  return (
    <Fragment>
      <div className="messages-overlay">
        <div className="request-box">
          <i
            className="fas fa-times fa-3x message-x"
            onClick={() => setShowBefriend({ request: false, confirm: false })}
          ></i>
          <div className="flex-center">
            <div className="online-avi-container">
              <div
                className={`avi-color-border ${
                  role === "innovator"
                    ? "green"
                    : role === "mentor"
                    ? "red"
                    : role === "employer"
                    ? "blue"
                    : null
                }`}
              >
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                  className="drop-down-result-avi"
                  alt="avatar"
                />
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span
                    className={`${
                      role === "innovator"
                        ? "green"
                        : role === "mentor"
                        ? "red"
                        : role === "employer"
                        ? "blue"
                        : null
                    } name-font`}
                  >
                    {firstname} {lastname}
                  </span>
                </li>
                <li className="user-online-item">{jobtitle}</li>
                <li className="user-online-item">
                  {location.city}, {location.state}
                </li>
              </ul>
            </div>
          </div>
          <div className="user-request-text">
            Would you like to add{" "}
            <span
              className={`${
                role === "innovator"
                  ? "green"
                  : role === "mentor"
                  ? "red"
                  : role === "employer"
                  ? "blue"
                  : null
              } bold`}
            >
              {firstname} {lastname}
            </span>{" "}
            as a friend?
          </div>
          <div className="flex-center">
            <button
              className={`${
                role === "innovator"
                  ? "background-green"
                  : role === "mentor"
                  ? "background-red"
                  : role === "employer"
                  ? "background-blue"
                  : null
              } user-request-button`}
              onClick={() =>
                addFollowingFriend({ channelid }) &&
                setShowBefriend({ request: false, confirm: true })
              }
            >
              <i className="far fa-check-circle fa-sm mr-5"></i>
              Confirm
            </button>
            <button
              className={`${
                role === "innovator"
                  ? "background-green"
                  : role === "mentor"
                  ? "background-red"
                  : role === "employer"
                  ? "background-blue"
                  : null
              } user-request-button`}
              onClick={() =>
                setShowBefriend({ request: false, confirm: false })
              }
            >
              <i className="fas fa-times fa-sm mr-5 bold"></i>
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

Befriend.propTypes = {
  auth: PropTypes.object.isRequired,
  addFollowingFriend: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  friend: state.friend,
});

export default connect(mapStateToProps)(Befriend);
